import { Trans } from "@lingui/react/macro"

interface Props {
  retryButton?: React.ReactNode
}

export function ErrorMessage(props: Props) {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4">
      <div className="flex max-w-[600px] flex-col items-center gap-2 px-4">
        <div className="flex flex-col items-center gap-1">
          <h2 className="text-center text-2xl">
            <Trans>Uh-oh! Something went wrong</Trans>
          </h2>
          <span className="text-center text-foreground/60">
            <Trans>
              Give it another try. If that doesn't work, check back in a few
              minutes.
            </Trans>
          </span>
        </div>
      </div>
      {props.retryButton}
    </div>
  )
}

export function ModalErrorMessage() {
  return (
    <div className="flex min-h-[200px] items-center justify-center">
      <ErrorMessage />
    </div>
  )
}
